import React, { Suspense, useCallback, useContext, useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { TostMsg } from "../../../App";
// import { getTicketListData, addTicket } from "./TicketService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import Papa from "papaparse";
import { saveAs } from "file-saver";
import { MultiSelect } from "primereact/multiselect";
import moment from "moment";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import {
  getTicketListData,
  addTicket,
} from "../TicketManagement/TicketService";
import { Chart } from "primereact/chart";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);
const defaultImage = "/images/placeholder_profile.png";

function AssetsListHtml() {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const toster = useContext(TostMsg);
  // const [ticketData, setTicketData] = useState([]);
  const [ticketDataCount, setTicketDataCount] = useState([]);
  const [noData, setNoData] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const selectedColumns = [
    "RequestTitle",
    "RequestNumber",
    "CreatedDate",
    "EmployeeFullName",
    "RequestStatus",
    "CategoryName",
    "SubCategoryName",
    "AssignToName",
    "Priority",
    "PriorityName",
    "Severity",
    "SeverityName",
  ];
  const [selectedTicket, setSelectedTicket] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [ticketStatusType, setTicketStatusType] = useState([]);
  const [ticketCategoryType, setTicketCategoryType] = useState([]);
  const [ticketSubcategoryType, setTicketSubcategoryType] = useState([]);
  const [ticketSubcategoryTypeSelected, setTicketSubcategoryTypeSelected] =
    useState([]);
  const [ticketPriorityType, setTicketPriorityType] = useState([]);
  const [ticketSeverityType, setTicketSeverityType] = useState([]);
  const [selectedTableStatus, setSelectedTableStatus] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedTableCategory, setSelectedTableCategory] = useState(null);
  const [selectedTableSubCategory, setSelectedTableSubCategory] =
    useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [selectedServerity, setSelectedServerity] = useState(null);
  const [filterStartDate, setFilterStartDate] = useState("02/01/2016");
  const [filterEndDate, setFilterEndDate] = useState("02/01/2029");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [selectedAssingToName, setSelectedAssingToName] = useState(null);
  const [employeDetails, setEmployeDetails] = useState([]);
  const [selectedRaiseBy, setSelectedRaiseBy] = useState(null);
  const [ticketDataMessage, setTicketDataMessage] = useState("");
  const [userUpdatePermission, setUserUpdatePermission] = useState(false);
  const [userAddPermission, setUserAddPermission] = useState(false);

  useEffect(() => {
    // GetMasterSystemAlertList("Ticket_Unavailable", 2);
    getTicketData(currentPage, rowsPerPage, debouncedSearchTerm);
    fetchEmployeeIdData();
    permissionAccouncementList();
    getMasterTicketStatus();
    getMasterTicketCategory();
    getMasterTicketSubCategory();
    getMasterTicketPriority();
    getMasterTicketSeverity();
  }, []);

  const [ticketData, setTicketData] = useState([
    {
      RequestNumber: "RA-001",
      RequestTitle: "Laptop",
      CreatedDate: "2025-10-20",
      EmployeeFullName: "Ravi Kumar",
      RequestStatus: "In Use",
      CategoryName: "Hardware",
      SubCategoryName: "Electronics",
      AssignToName: "IT Department",
      PriorityName: "2023",
      SeverityName: "8 GB",
      VendorName: "Dell",
      ResponseDate: "2025-10-25",
      Brand: "HP",
      Processor: "intel",
      Gen: "V4",
      Storage: "12GB",
      CurrentOwner: "Abhi",
      OperatingSystem: "window",
      CurrentIP: "193.103.102.98",
      LastIssuedDate: "2025-09-15",
      IssueLetter: "R56Y78YU",
    },
    {
      RequestNumber: "RA-002",
      RequestTitle: "Printer",
      CreatedDate: "2025-09-12",
      EmployeeFullName: "Neha Sharma",
      RequestStatus: "Under Repair",
      CategoryName: "Office Equipment",
      SubCategoryName: "Printing",
      AssignToName: "Maintenance",
      PriorityName: "2022",
      SeverityName: "16 GB",
      VendorName: "HP",

      ResponseDate: "2025-10-25",
      Brand: "HP",
      Processor: "intel",
      Gen: "V4",
      Storage: "12GB",
      CurrentOwner: "Abhi",
      OperatingSystem: "window",
      CurrentIP: "193.103.102.98",
      LastIssuedDate: "2025-09-15",
      IssueLetter: "R56Y78YU",
    },
    {
      RequestNumber: "RA-003",
      RequestTitle: "Monitor",
      CreatedDate: "2025-08-08",
      EmployeeFullName: "Ankit Verma",
      RequestStatus: "Working",
      CategoryName: "Hardware",
      SubCategoryName: "Display",
      AssignToName: "Admin Dept",
      PriorityName: "2024",
      SeverityName: "32 GB",
      VendorName: "Lenovo",
      ResponseDate: "2025-08-10",
      Brand: "HP",
      Processor: "intel",
      Gen: "V4",
      Storage: "12GB",
      CurrentOwner: "Abhi",
      OperatingSystem: "window",
      CurrentIP: "193.103.102.98",
      LastIssuedDate: "2025-09-15",
      IssueLetter: "R56Y78YU",
    },
  ]);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Ticket.Update") {
        setUserUpdatePermission(true);
      } else if (UserPermission.PermissionName == "Ticket.Add") {
        setUserAddPermission(true);
      }
    });
  };

  async function getTicketData(pageNumber, pageSize, debouncedSearchTerm) {
    setTicketDataMessage("Loding...");
    const searchStatusValue = selectedTableStatus
      ?.map((emp) => emp.Id)
      .join(",");
    const searchCategoryValue = selectedTableCategory
      ?.map((emp) => emp.Id)
      .join(",");
    const searchSubCategoryValue = selectedTableSubCategory
      ?.map((emp) => emp.Id)
      .join(",");
    const searchPriorityValue = selectedPriority
      ?.map((emp) => emp.Id)
      .join(",");
    const searchSeverityName = selectedServerity
      ?.map((emp) => emp.Id)
      .join(",");
    const searchAssingToName = selectedAssingToName
      ?.map((emp) => emp.Id)
      .join(",");
    const searchRaiseBy = selectedRaiseBy?.map((emp) => emp.Id).join(",");
    let serchTitle;
    let searchStartDate;
    let searchEndDate;

    if (debouncedSearchTerm?.requestTitle) {
      serchTitle = debouncedSearchTerm?.requestTitle;
    } else if (debouncedSearchTerm?.CreatedDate) {
      searchStartDate = debouncedSearchTerm?.CreatedDate;
    } else if (debouncedSearchTerm?.EndDate) {
      searchEndDate = debouncedSearchTerm?.EndDate;
    }
    setIsloading(true);
    const params = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: userDetails?.EmpId,
      RaisedByEmpId: searchRaiseBy ?? "",
      AssignedToId: searchAssingToName ?? "",
      TicketId: 0,
      RequestStatusId: searchStatusValue ?? "",
      RequestCategoryId: searchCategoryValue ?? "",
      RequestSubCategoryId: searchSubCategoryValue ?? "",
      PriorityId: searchPriorityValue ?? "",
      SeverityId: searchSeverityName ?? "",
      Search: serchTitle ? serchTitle : "",
      filterStartDate: searchStartDate ? searchStartDate : filterStartDate,
      filterEndDate: searchEndDate ? searchEndDate : filterEndDate,
      PageNumber: pageNumber + 1,
      PageSize: pageSize,
      IsDeleted: 0,
      RequestNumber: "",
    };

    try {
      const data = await getTicketListData(params);
      setIsloading(true);
      let ticketDetailData = await data;
      var romoveDuplicateData = ticketDetailData?.Data?.OrgEmpRequests?.reduce(
        (unique, o) => {
          if (!unique.some((obj) => obj.Id === o.Id)) {
            unique.push(o);
          }
          return unique;
        },
        []
      );

      setTicketData(romoveDuplicateData);
      setTicketDataCount(ticketDetailData?.Data?.TicketStatusCounts);
      setTotalRecords(ticketDetailData?.Data?.TotalTicketCount);
      setIsloading(false);
    } catch {
      setIsloading(false);
      toster.error("Something went wrong");
    } finally {
      if (romoveDuplicateData?.length === 0) {
        setTicketDataMessage("NO DATA FOUND.");
      }
    }
  }

  const onPageChange = (e) => {
    setCurrentPage(e.page);
    setRowsPerPage(e.rows);
    getTicketData(e.page, e.rows, debouncedSearchTerm);
  };

  async function GetMasterSystemAlertList(message, type) {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }

  const requestTitle = (rowData) => {
    const maxLength = 25;
    const truncatedTitle =
      rowData.RequestTitle.length > maxLength
        ? `${rowData.RequestTitle.substring(0, maxLength)}...`
        : rowData.RequestTitle;

    if (
      userDetails?.EmpId === rowData?.AssignedToId &&
      userUpdatePermission === false
    ) {
      return (
        <div className="d-flex align-items-center">
          <Link
            to={`/Ticket/Detail/${rowData.RequestNumber}`}
            title={rowData.RequestTitle}
            className="editbtncss me-2"
          >
            {truncatedTitle}
          </Link>
        </div>
      );
    } else if (
      userDetails?.EmpId === rowData?.AssignedToId ||
      userUpdatePermission === true
    ) {
      return (
        <div className="d-flex">
          <Link
            to={`/Ticket/Detail/${rowData.RequestNumber}`}
            title={rowData.RequestTitle}
            className="editbtncss"
          >
            {truncatedTitle}
          </Link>
        </div>
      );
    } else {
      return (
        <div className="d-flex">
          <div title={rowData.RequestTitle} className="editbtncss">
            {truncatedTitle}
          </div>
        </div>
      );
    }
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const nameBodyTemplate = (rowData) => {
    return (
      <Link to={`/Profile/${rowData.EmployeeUserGUID}`}>
        <div className="d-flex">
          <img
            src={rowData?.EmployeeProfileImage || defaultImage}
            onError={handleImageError}
            className="rounded-lg me-2"
            width="18"
            alt=""
          />{" "}
          <span className="w-space-no">{rowData?.EmployeeFullName}</span>
        </div>
      </Link>
    );
  };

  const assignBodyTemplate = (rowData) => {
    if (rowData.AssignedToId != 0) {
      return (
        <Link to={`/Profile/${rowData.AssignToUserGUID}`}>
          <div className="d-flex">
            <img
              src={rowData?.AssignToProfileImage || defaultImage}
              onError={handleImageError}
              className="rounded-lg me-2"
              width="18"
              alt=""
            />{" "}
            <span className="w-space-no">{rowData?.AssignToName}</span>
          </div>
        </Link>
      );
    }
    return <span>Not Assigned</span>;
  };

  const serverityContent = (rowData) => {
    return (
      <span>
        {rowData?.SeverityName == "Low" && <span className="low-pri">Low</span>}
        {rowData?.SeverityName == "Medium" && (
          <span className="med-pri">Medium</span>
        )}
        {rowData?.SeverityName == "High" && (
          <span className="high-pri">High</span>
        )}
      </span>
    );
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleInputChange = (e) => {
    const empIdsString = e?.value?.map((emp) => emp.Id).join(",");
    let { name, value } = e.target;
    if (empIdsString) {
      value = empIdsString;
    }
    if (name == "CreatedDate") {
      setStartDate(value);
      let startDate = formatDate(value);
      value = startDate;
      setFilterStartDate(value);
    } else if (name == "EndDate") {
      setEndDate(value);
      let endDate = formatDate(value);
      value = endDate;
      setFilterEndDate(formatDate(value));
    }
    setSearchTerm({ [name]: value });
  };

  const onSelectionChange = (event) => {
    const selectedValues = filterColumns(event.value);
    setSelectedTicket(selectedValues);
    const startIndex = currentPage * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const visibleRows = ticketData.slice(startIndex, endIndex);
    setSelectAll(selectedValues.length === visibleRows.length);
  };

  const onSelectAllChange = (event) => {
    const isChecked = event.checked;
    const startIndex = currentPage * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const visibleRows = filterColumns(ticketData.slice(startIndex, endIndex));

    if (isChecked) {
      setSelectAll(true);
      setSelectedTicket([...selectedTicket, ...visibleRows]);
    } else {
      setSelectAll(false);
      const updatedSelection = selectedTicket.filter(
        (ticket) => !visibleRows.some((row) => row.TicketNO === ticket.TicketNO)
      );
      setSelectedTicket(updatedSelection);
    }
  };

  const filterColumns = (data) => {
    return data.map((item) =>
      selectedColumns.reduce((obj, key) => {
        if (item[key] !== undefined) {
          obj[key] = item[key];
        }
        return obj;
      }, {})
    );
  };

  async function fetchEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    setIsloading(true);
    try {
      let employeesList = await getEmployeeList(params);
      setEmployeDetails(employeesList.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  const toggleFilterVisibility = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  function exportToCSV() {
    if (selectedTicket.length > 0) {
      const csv = Papa.unparse(selectedTicket);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "Tickets.csv");
    } else {
      toster.current.warn("Please select at least one ticket");
    }
  }

  async function getMasterTicketStatus() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "TicketStatusType",
    };
    try {
      const data = await GetMasterTypeData(params);
      const sortedStatusData = data?.Data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      setTicketStatusType(sortedStatusData);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Category",
    };
    try {
      const data = await GetMasterTypeData(params);
      const sortedCategoryData = data?.Data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      setTicketCategoryType(sortedCategoryData);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketSubCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Subcategory",
    };
    try {
      const data = await GetMasterTypeData(params);
      const sortedSubcategoryData = data?.Data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      setTicketSubcategoryType(sortedSubcategoryData);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketPriority() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Priority",
    };
    try {
      const data = await GetMasterTypeData(params);
      const sortedPriorityData = data?.Data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      setTicketPriorityType(sortedPriorityData);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function getMasterTicketSeverity() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "Severity",
    };
    try {
      const data = await GetMasterTypeData(params);
      const sortedSeverityData = data?.Data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      );
      setTicketSeverityType(sortedSeverityData);
    } catch (error) {
      setIsloading(false);
    }
  }

  // const onRowEditComplete = async (e) => {
  //     setIsloading(true);
  //     // const priorityObject = ticketPriorityType.find(
  //     //     (priority) => priority.Name === e.newData?.PriorityName
  //     // );
  //     // const severityObject = ticketSeverityType.find(
  //     //     (priority) => priority.Name === e.newData?.SeverityName
  //     // );
  //     // const categoryObject = ticketCategoryType.find(
  //     //     (priority) => priority.Name === e.newData?.CategoryName
  //     // );
  //     // const subCategoryObject = ticketSubcategoryTypeSelected.find(
  //     //     (priority) => priority.Name === e.newData?.SubCategoryName
  //     // );
  //     // const requestStatus = ticketStatusType.find(
  //     //     (staus) => staus.Name === e.newData?.RequestStatus
  //     // );
  //     // const assignTo = employeDetails.find(
  //     //     (name) => name.FullName === e.newData?.AssignToName
  //     // );

  //     // let params = {
  //     //     Id: e.data?.Id,
  //     //     OrgId: e.data?.OrgId,
  //     //     EmpId: e.data?.EmpId,
  //     //     RequestTitle: e.data?.RequestTitle,
  //     //     RequestDescription: e.data?.RequestDescription,
  //     //     RequestCategoryId: Number(categoryObject ? categoryObject.Id : null),
  //     //     RequestSubCategoryId: Number(
  //     //         subCategoryObject ? subCategoryObject.Id : e.data?.RequestSubCategoryId
  //     //     ),
  //     //     Comment: e.newData?.Comment,
  //     //     Severity: Number(severityObject ? severityObject.Id : null),
  //     //     Priority: Number(priorityObject ? priorityObject.Id : null),
  //     //     AssignedToId: Number(assignTo ? assignTo.EmpId : null),
  //     //     RequestStatusId: Number(requestStatus ? requestStatus.Id : null),
  //     // };
  //     // try {
  //     //     await addTicket(params);
  //     //     GetMasterSystemAlertList("Ticket_Updated");
  //     //     setEditTicketId(0);
  //     //     getTicketData(currentPage, rowsPerPage, debouncedSearchTerm);
  //     // } catch (error) {
  //     //     setIsloading(false);
  //     //     toster.current.errpr("Something went wrong.");
  //     // }
  // };

  // const priorityEditor = (options) => {
  //     return (
  //         <Dropdown
  //             value={ticketPriorityType.find(
  //                 (priority) => priority.Name == options.value
  //             )}
  //             onChange={(e) => options.editorCallback(e.value.Name)}
  //             options={ticketPriorityType}
  //             optionLabel="Name"
  //             placeholder="Priority"
  //             className="w-full md:w-14rem"
  //         />
  //     );
  // };

  // const serverityEditor = (options) => {
  //     return (
  //         <Dropdown
  //             value={ticketSeverityType.find(
  //                 (serverity) => serverity.Name == options.value
  //             )}
  //             onChange={(e) => options.editorCallback(e.value.Name)}
  //             options={ticketSeverityType}
  //             optionLabel="Name"
  //             placeholder="Severity"
  //             className="w-full md:w-14rem"
  //         />
  //     );
  // };

  // const [editTicketId, setEditTicketId] = useState(0);
  // const onRowEditInit = async (e) => {
  //     setEditTicketId(e.data.Id);
  // };

  // const categoryEditor = (options) => {
  //     let categoryId = ticketCategoryType.find(
  //         (catName) => catName.Name == options.value
  //     );
  //     if (categoryId) {
  //         setSelectedCategory(categoryId);
  //         let seletedSubCat = ticketSubcategoryType.filter((item) => {
  //             return item.CategoryId === categoryId.Id;
  //         });
  //         setTicketSubcategoryTypeSelected(seletedSubCat);
  //     }

  //     return (
  //         <Dropdown
  //             value={ticketCategoryType.find(
  //                 (category) => category.Name == options.value
  //             )}
  //             onChange={(e) => {
  //                 options.editorCallback(e.value.Name);
  //                 const filtered = ticketSubcategoryType.filter(
  //                     (item) => item.CategoryId === e.value.Id
  //                 );
  //                 setTicketSubcategoryTypeSelected(filtered);
  //                 setTicketData((prev) =>
  //                     prev.map((row) =>
  //                         row.Id === editTicketId ? { ...row, SubCategoryName: "" } : row
  //                     )
  //                 );
  //             }}
  //             options={ticketCategoryType}
  //             optionLabel="Name"
  //             placeholder="Category"
  //             className="w-full md:w-14rem"
  //         />
  //     );
  // };

  // const subCategoryEditor = (options) => {
  //     return (
  //         <Dropdown
  //             value={ticketSubcategoryTypeSelected.find(
  //                 (subCategory) => subCategory.Name == options.value
  //             )}
  //             onChange={(e) => {
  //                 options.editorCallback(e.value.Name);
  //                 setTicketData((prev) =>
  //                     prev.map((row) =>
  //                         row.Id === editTicketId
  //                             ? { ...row, SubCategoryName: e.value.Name }
  //                             : row
  //                     )
  //                 );
  //             }}
  //             options={ticketSubcategoryTypeSelected}
  //             optionLabel="Name"
  //             placeholder="SubCategory"
  //             className="w-full md:w-14rem"
  //         />
  //     );
  // };

  // const requestStatusEditor = (options) => {
  //     return (
  //         <Dropdown
  //             value={ticketStatusType.find((status) => status.Name == options.value)}
  //             onChange={(e) => options.editorCallback(e.value.Name)}
  //             options={ticketStatusType}
  //             optionLabel="Name"
  //             placeholder="Status"
  //             className="w-full md:w-14rem"
  //         />
  //     );
  // };

  // const assignToEditor = (options) => {
  //     return (
  //         <Dropdown
  //             value={employeDetails.find((name) => name.FullName == options.value)}
  //             onChange={(e) => options.editorCallback(e.value.FullName)}
  //             options={employeDetails}
  //             optionLabel="FullName"
  //             placeholder="Assign"
  //             itemTemplate={employeeOptionTemplate}
  //             filter
  //             className="w-full md:w-14rem"
  //         />
  //     );
  // };

  // const RaiseByEditor = (options) => {
  //     return (
  //         <div className="d-flex">
  //             <span className="w-space-no">{options.value}</span>
  //         </div>
  //     );
  // };

  const employeeOptionTemplate = (option) => {
    return (
      <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
        <LazyImage alt={option.FullName} src={option.ProfileImage} width="32" />
        <span>{option.FullName}</span>
      </div>
    );
  };

  useEffect(() => {
    let categoryId = selectedCategory?.Id
      ? selectedCategory.Id
      : selectedCategory;
    if (selectedCategory) {
      let seletedSubCat = ticketSubcategoryType.filter(
        (item) => item.CategoryId === categoryId
      );
      setTicketSubcategoryTypeSelected(seletedSubCat);
    }
  }, [selectedCategory]);

  useEffect(() => {
    const filtered = ticketSubcategoryType?.filter((sub) =>
      selectedTableCategory.some((sel) => sel.Id === sub.CategoryId)
    );
    setTicketSubcategoryTypeSelected(filtered);
  }, [selectedTableCategory]);

  useEffect(() => {
    if (selectedAssingToName?.EmpId) {
      getTicketData(currentPage, rowsPerPage, debouncedSearchTerm);
    } else if (selectedRaiseBy?.EmpId) {
      getTicketData(currentPage, rowsPerPage, debouncedSearchTerm);
    } else if (selectedRaiseBy == "") {
      getTicketData(currentPage, rowsPerPage, debouncedSearchTerm);
    } else if (debouncedSearchTerm) {
      getTicketData(currentPage, rowsPerPage, debouncedSearchTerm);
    }
  }, [
    currentPage,
    rowsPerPage,
    debouncedSearchTerm,
    selectedAssingToName,
    selectedRaiseBy,
  ]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");
    const data = {
      labels: ["Laptop", "Chair", "Table", "Server", "AC", "Fan", "Light"],
      datasets: [
        {
          type: "bar",
          label: "Ready for Use",
          backgroundColor: documentStyle.getPropertyValue("--purple-700"),

          data: [50, 25, 12, 48, 90, 76, 42],
        },
        {
          type: "bar",
          label: "Under Repair Process",
          backgroundColor: documentStyle.getPropertyValue("--yellow-500"),

          data: [21, 84, 24, 75, 37, 65, 34],
        },
        {
          type: "bar",
          label: "Rejected",
          backgroundColor: documentStyle.getPropertyValue("--red-600"),
          data: [41, 52, 24, 74, 23, 21, 32],
        },
      ],
    };
    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        tooltips: {
          mode: "index",
          intersect: false,
        },
        legend: {
          labels: {
            color: textColor,
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
          },
        },
        y: {
          stacked: true,
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
          },
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, []);

  const actionBodyTemplate = (rowData) => {
    return (
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ gap: "5px" }}
      >
        <Link to={`/Profile/${rowData.GUID}`} className="view-teamdetail">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-eye"
            viewBox="0 0 16 16"
          >
            <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
            <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
          </svg>
        </Link>

        <Link className="view-teamdetail">
          <svg
            // onClick={() => redirectToAnotherPage(rowData)}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-chat-text"
            viewBox="0 0 16 16"
          >
            <title>Chat</title>
            <path d="M2.678 11.894a1 1 0 0 1 .287.801 11 11 0 0 1-.398 2c1.395-.323 2.247-.697 2.634-.893a1 1 0 0 1 .71-.074A8 8 0 0 0 8 14c3.996 0 7-2.807 7-6s-3.004-6-7-6-7 2.808-7 6c0 1.468.617 2.83 1.678 3.894m-.493 3.905a22 22 0 0 1-.713.129c-.2.032-.352-.176-.273-.362a10 10 0 0 0 .244-.637l.003-.01c.248-.72.45-1.548.524-2.319C.743 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.52.263-1.639.742-3.468 1.105" />
            <path d="M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8m0 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5" />
          </svg>
        </Link>
      </div>
    );
  };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>
        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center mb-4">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">Assets Dashboard</h2>
              </div>
              {userAddPermission && (
                <div className="rightside-tabs">
                  <Link to="/Assets/addHtml">
                    <button className="add-newticket w-auto float-right ">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-plus"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                      </svg>{" "}
                      Add Assets
                    </button>
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-12">
            <div className="page-content-inner all-projects">
              <div className="row">
                <div className="col-lg-6">
                  <div className="assets-summary tickets-summary">
                    <div className="column">
                      <img src="/images/org-img/leave/popup-backimg.png" />
                      <Link to="">
                        <span>47</span>
                        <div>
                          <p>Assets in Warrenty</p>
                        </div>
                      </Link>
                      <div className="progress">
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{ width: "25%" }}
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>

                    <div className="column">
                      <img src="/images/org-img/leave/popup-backimg.png" />
                      <Link to="">
                        <span>97</span>
                        <div>
                          <p>Assets in stack</p>
                        </div>
                      </Link>
                      <div className="progress">
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{ width: "25%" }}
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>

                    <div className="column">
                      <img src="/images/org-img/leave/popup-backimg.png" />
                      <Link to="">
                        <span>27</span>
                        <div>
                          <p>Total Assets</p>
                        </div>
                      </Link>
                      <div className="progress">
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{ width: "25%" }}
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>

                    <div className="column">
                      <img src="/images/org-img/leave/popup-backimg.png" />
                      <Link to="">
                        <span>47</span>
                        <div>
                          <p>New Assets</p>
                        </div>
                      </Link>
                      <div className="progress">
                        <div
                          className="progress-bar bg-success"
                          role="progressbar"
                          style={{ width: "25%" }}
                          aria-valuenow="25"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="asset-chart">
                    <Chart type="bar" data={chartData} options={chartOptions} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-12 mt-5">
            <div className="card">
              <div className="card-body">
                <div className="form-head d-flex flex-wrap align-items-center mb-3">
                  <div className="me-auto w-20">
                    <strong
                      className="ticket-title m-0"
                      style={{ fontWeight: "bolder" }}
                    >
                      Asstes ({totalRecords})
                    </strong>
                  </div>
                  <div className="actionbutton-tickets">
                    <InputText
                      name="requestTitle"
                      className="form-control mr-2"
                      placeholder="Search"
                      onChange={handleInputChange}
                    />
                    <div className="dropdown documents-dropdown">
                      <button
                        className="btn btn-purple me-2"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-download me-1"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                        </svg>{" "}
                        Download
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a className="dropdown-item" href="#">
                            PDF Report
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            Excel Report
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="form-head d-flex flex-wrap align-items-center bottom-head">
                  <div className="saving-btn00 d-flex w-100 assets-field">
                    <div className="d-flex d-flexx">
                      <MultiSelect
                        name="assignToName"
                        className="w-full "
                        value={selectedAssingToName}
                        onChange={(e) => {
                          setSelectedAssingToName(e.value);
                          handleInputChange(e);
                        }}
                        options={employeDetails}
                        optionLabel="FullName"
                        filter
                        placeholder="Asset Type"
                        maxSelectedLabels={3}
                        selectedItemsLabel="{0} Assign to selected"
                        itemTemplate={employeeOptionTemplate}
                      />

                      <MultiSelect
                        name="assignToName"
                        className="w-full"
                        value={selectedRaiseBy}
                        onChange={(e) => {
                          setSelectedRaiseBy(e.value);
                          handleInputChange(e);
                        }}
                        options={employeDetails}
                        optionLabel="FullName"
                        filter
                        placeholder="Asset Owner"
                        maxSelectedLabels={3}
                        selectedItemsLabel="{0} Raise by selected"
                        itemTemplate={employeeOptionTemplate}
                      />

                      <MultiSelect
                        name="requestStatus"
                        value={selectedTableStatus}
                        onChange={(e) => {
                          setSelectedTableStatus(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketStatusType}
                        optionLabel="Name"
                        filter
                        maxSelectedLabels={3}
                        selectedItemsLabel="{0} Status selected"
                        placeholder="Warranty Status"
                        className="w-full "
                      />
                      <MultiSelect
                        name="requestStatus"
                        value={selectedTableStatus}
                        onChange={(e) => {
                          setSelectedTableStatus(e.value);
                          handleInputChange(e);
                        }}
                        options={ticketStatusType}
                        optionLabel="Name"
                        filter
                        maxSelectedLabels={3}
                        selectedItemsLabel="{0} Status selected"
                        placeholder="Assets Status"
                        className="w-full "
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="table table-bordered dataTable no-footer tickettable assettable">
                    <DataTable
                      value={ticketData}
                      paginator
                      rows={10}
                      responsiveLayout="scroll"
                      dataKey="RequestNumber"
                      className="p-datatable-striped"
                      emptyMessage="No data available"
                    >
                      <Column
                        field="RequestNumber"
                        header="Asset Serial No"
                        style={{ minWidth: "10rem" }}
                      />
                      <Column
                        field="RequestTitle"
                        header="Asset Type"
                        style={{ minWidth: "10rem" }}
                      />
                      <Column
                        field="CreatedDate"
                        header="Asset Tally Name"
                        body={(rowData) =>
                          moment(rowData.CreatedDate).format("MMM DD, YYYY")
                        }
                      />
                      <Column field="EmployeeFullName" header="Mac Address" />
                      <Column field="RequestStatus" header="Status" />
                      <Column field="CategoryName" header="Description" />
                      <Column
                        field="SubCategoryName"
                        header="Date of Purchase"
                      />
                      <Column field="AssignToName" header="Purchase Month" />
                      <Column field="PriorityName" header="Purchase Year" />

                      <Column field="VendorName" header="Vendor" />
                      <Column field="SeverityName" header="RAM" />
                      <Column field="Brand" header="Brand" />
                      <Column field="Processor" header="Processor" />
                      <Column field="Gen" header="Gen" />
                      <Column field="Storage" header="Storage" />
                      <Column field="CurrentOwner" header="Current Owner" />
                      <Column
                        field="Operating System"
                        header="Operating System"
                      />
                      <Column field="CurrentIP" header="Current IP" />
                      <Column
                        field="LastIssuedDate"
                        header="Last Issued Date"
                      />
                      <Column field="IssueLetter" header="Issue Letter No" />
                      <Column
                        header="Action"
                        body={
                          <div className="d-flex">
                            <button className="editactions me-2">
                              <img
                                src="/images/tickets/edit-ico.svg"
                                title="Edit"
                              />
                            </button>
                            <button className="editactions me-2" title="Delete">
                              <img
                                src="/images/tickets/delete.svg"
                                title="Delete"
                              />
                            </button>
                            <Link to="/Assets/DetailHtml">
                             <button className="editactions me-2" title="View">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-eye"
                                viewBox="0 0 16 16"
                              >
                                <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                              </svg>
                            </button>
                            </Link>
                           
                            <a className=" me-2" title="Transfer">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrow-left-right"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"
                                />
                              </svg>
                            </a>
                            <a className="" title="">
                              Return to Inventory
                            </a>
                          </div>
                        }
                        style={{ width: "361px" }}
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="review-request"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">
                Form Submitted Successfully. Now Sent the Review Request.
              </h5>
            </div>
            <div className="modal-body text-center">
              <form>
                <div className="form-group text-left">
                  <label>Request to</label>
                  <select className="default-select form-control wide mb-3">
                    <option selected disabled>
                      Select
                    </option>
                    <option>Employee Review</option>
                    <option>Review</option>
                    <option>HR Review</option>
                  </select>
                </div>
                <div className="form-group text-left">
                  <label className="mt-3">Add your Comment</label>
                  <textarea
                    rows="4"
                    cols="1"
                    className="form-control"
                  ></textarea>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button type="button" className="btn btn-primary">
                Sumbit
              </button>
            </div>
          </div>
        </div>
      </div>
      {Isloading ? (
        <Suspense fallback={<div>Loading...</div>}>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default AssetsListHtml;
